
// -Personnel                    -人员
//    --Issuance of records   -  下发记录
// -Device                        - 设备
// -Access Control           -门禁管理
//    --Door Access               - 门禁权限
//    --Permission Inquiry     - 权限查询  
//    --Passage records          -门禁记录
// -Approval                   -  审批管理
// -Organization              -机构设置
//    --Sub-manager             -子管理员




let authPages = {
  path: "/",
  component: () => import("@/pages/Dashboard/Pages/AuthLayout.vue"),
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/pages/Dashboard/Pages/Login.vue"),
    },
    {
      path: "/register",
      name: "Register",
      component: () => import("@/pages/Dashboard/Pages/Register.vue"),
    },{
      path: "/forgetpw",
      name: "Forget Passwd",
      component: () => import("@/pages/Dashboard/Pages/ForgetPw.vue"),
    }
  ],
};
let equipPages = {
  path: "/equipmng",
  component: () => import("@/pages/Dashboard/Layout/DashboardLayout.vue"),
  name: "Equip",
  children: [
    {
      path: "equiparea",
      name: "m_equip_area",
      component: () => import("@/pages/Dashboard/PageComponents/EquipMng/EquipArea/EquipArea.vue"),
    },
    {
      path: "devicelist",
      name: "m_dev_list",
      component: () => import("@/pages/Dashboard/PageComponents/EquipMng/DeviceList/DeviceList.vue"),
    },
  ],
};
let attendancePages = {
  path: "/attdmng",
  component: () => import("@/pages/Dashboard/Layout/DashboardLayout.vue"),
  name: "Attendance",
  children: [
    {
      path: "myqppr",
      name: "m_my_qpproval",
      component: () => import("@/pages/Dashboard/PageComponents/AttdMng/MyAppr/MyAppr.vue"),
    },
  ],
};
let oragniPages = {
  path: "/oragni",
  component: () => import("@/pages/Dashboard/Layout/DashboardLayout.vue"),
  name: "Oragni",
  children: [
    {
      path: "instituInfo",
      name: "m_institu_info",
        component: () => import("@/pages/Dashboard/PageComponents/Oragni/InstituInfo/InstituInfo.vue"),
    },
  ],
};

let peoplePages = {
  path: "/peoplemng",
  component: () => import("@/pages/Dashboard/Layout/DashboardLayout.vue"),
  name: "People Mng",
  children: [
    {
      path: "personlist",
      name: "m_per_list",
        component: () => import("@/pages/Dashboard/PageComponents/PeopleMng/PersonList/PersonList.vue"),
    },
  ],
}

const routes = [
  {
    path: "/",
    redirect: "/home",
    name: "base",
  },
  authPages,
  equipPages,
  attendancePages,
  oragniPages,
  peoplePages,
  {
    path: "/",
    component: () => import("@/pages/Dashboard/Layout/DashboardLayout.vue"),
    children: [
      // 实际的
      {
        path: "home",
        name: "m_home",
        component: () => import("@/pages/Dashboard/Home/Home.vue"),
      }, 
    ],
  },{
    path: "/manual_entry",
    name: "Manual Entry",
    component: () => import("@/pages/Dashboard/Other/ManEntry.vue"),
  },{
    path: "/:path(.*)",
    redirect: "/home",
    // component: () => import("@/pages/Dashboard/PageNotFound.vue"),
  },
    
];

export default routes;
